import React from 'react';

import { formatNumber } from '../common/Util';

import Typography from './common/Typography';
import { useTranslation } from 'react-i18next';

const TotalSection = ({ total = '5000000' }) => {
  const { t } = useTranslation('common');

  return (
    <div className="displayFlex" style={{ justifyContent: 'flex-end' }}>
      <Typography variant="body2Bold">
        {t('total')} : {formatNumber(total)} 원
      </Typography>
    </div>
  );
};

export default TotalSection;
